export default {
      id: "vt-tax-usage",
      viewBox: "0 0 16 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#vt-tax",
      toString: function () {
        return this.url;
      }
    }